<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="row">
            <div class="col-12">
                <div class="page_action">
                    <div class="tw-w-full text-right">
                        <button
                            type="button"
                            class="btn btn-sm btn-dark"
                            data-toggle="modal"
                            data-target="#addPayment"
                        >
                            <i class="fa fa-plus"></i>
                            เพิ่มช่องทางการชำระเงิน
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-hover mt-3 mb-0 c_list">
                <thead>
                    <tr>
                        <th>ธนาคาร</th>
                        <th>เลขบัญชี</th>
                        <th>ชื่อบัญชี</th>
                        <th colspan="3"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="salePagePaymentData.length === 0">
                        <td class="text-center" colspan="5">
                            <span
                                class="tw-cursor-pointer"
                                data-toggle="modal"
                                data-target="#addPayment"
                            >
                                ไม่พบบัญชี คลิกเพื่อเพิ่มบัญชี
                            </span>
                        </td>
                    </tr>
                    <tr v-for="(item, index) in salePagePaymentData" :key="index">
                        <td class="row">
                            <div class="px-2">
                                <i :class="`bank bank-logo bank-${item.banks.bank_code}`"></i>
                            </div>
                            <div class="tw-flex tw-items-center">
                                {{ item.account_name }}
                            </div>
                        </td>
                        <td>{{ item.account_code }}</td>
                        <td>{{ item.holder_name }}</td>
                        <td class="text-right">
                            <button
                                @click="confirmDelete(item.id)"
                                type="button"
                                data-type="confirm"
                                class="btn btn-sm btn-danger js-sweetalert"
                                title="Delete"
                            >
                                <i class="fa fa-trash-o"> ลบ</i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal" id="addPayment" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="tw-font-bold">
                            เพิ่มช่องทางการชำระเงิน
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="onClose"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="table-responsive">

                            <!-- payment lists -->
                            <div v-show="showPaymentLists">
                                <table class="table table_modal table-hover mt-3 mb-0 c_list">
                                    <thead>
                                        <tr class="tw-whitespace-nowrap">
                                            <th>ธนาคาร</th>
                                            <th>เลขบัญชี</th>
                                            <th>ชื่อบัญชี</th>
                                            <th colspan="3"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(item, index) in paymentData"
                                            :key="index"
                                        >
                                            <td class="tw-flex tw-whitespace-nowrap">
                                                <div class="px-2">
                                                    <i :class="`bank bank-logo bank-${item.banks.bank_code}`"></i>
                                                </div>
                                                <div class="tw-flex tw-items-center">
                                                    {{ item.account_name }}
                                                </div>
                                            </td>
                                            <td>{{ item.account_code }}</td>
                                            <td>{{ item.holder_name }}</td>
                                            <td class="text-right">
                                                <button
                                                    @click="addPaymentSalepage(item.id)"
                                                    type="button"
                                                    data-type="confirm"
                                                    class="btn btn-sm btn-dark"
                                                    title="Add"
                                                >
                                                    <i class="fa fa-plus"></i>
                                                    เพิ่มบัญชี
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="text-center mt-3">
                                    <span 
                                        v-show="!showAddNewPayment"
                                        class="tw-cursor-pointer tw-text-blue-500" 
                                        @click="newPayment">
                                            คลิกเพื่อเพิ่มบัญชี
                                    </span>
                                </div>
                            </div>
                            

                            <!-- add new payment -->
                            <div class="card" v-show="showAddNewPayment">
                                <div class="card-body">
                                    <div class="form-group" >
                                        <label>ชื่อธนาคาร</label>
                                        <vSelect 
                                            filterable 
                                            :options="banks" 
                                            label="label" 
                                            v-model="bankSelected"
                                            @search="getBanks"
                                            searchable
                                            class="mt-1" />
                                    </div>
                                    <div class="form-group">
                                        <label>เลขบัญชี</label>
                                        <input
                                            v-model="form.account_code"
                                            type="text"
                                            class="form-control tw-placeholder-gray-300"
                                            placeholder="เลขบัญชี"
                                            maxlength="18"
                                            required
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label>ชื่อบัญชี</label>
                                        <input
                                            v-model="form.holder_name"
                                            type="text"
                                            class="form-control tw-placeholder-gray-300"
                                            placeholder="ชื่อบัญชี"
                                            required
                                        />
                                    </div>
                                </div>
                                
                                <div class="card-footer tw-bg-white d-flex flex-row-reverse">
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-success px-3"
                                        @click="store"
                                    >
                                        บันทึก
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-default px-3 mr-2"
                                         @click="cancelAddPayment"
                                    >
                                        ยกเลิก
                                    </button>
                                    
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <div class="modal-footer">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import vSelect from "vue-select";

export default {
    props: {
        shop: {
            required: true,
            type: String
        },

        salePage: {
            required: true,
            type: Object
        }
    },
    components: {
        vSelect
    },
    data() {
        return {
            loading: false,
            status: {
                addPayment: false
            },
            salePagePaymentData: [],
            paymentData: [],
            banks: [],
            bankSelected: null,

            showPaymentLists: true,
            showAddNewPayment: false,

            form: {
                bank_id: null,
                account_code: null,
                holder_name: null,
            },

            loading: false
        };
    },
    mounted() {
        this.getData();
        this.getBanks('');
    },
    methods: {
        confirmDelete(id) {
            this.$swal({
                icon: "warning",
                title: "ต้องการลบบัญชีใช่ไหม?",
                text: "เมื่อกดยืนยัน บัญชีจะถูกลบ",
                confirmButtonText: "ยืนยัน",
                showCancelButton: true,
                cancelButtonText: "ยกเลิก",
                reverseButtons: true
            }).then(result => {
                if (result.isConfirmed) {
                    this.deletePaymentSalepage(id);
                }
            });
        },
        async addPaymentSalepage(id) {
            this.loading = true;
            const form = {
                payment_id: id
            };
            const url = `/backend/s/${this.shop}/payments/manage-salepage/${this.salePage.id}`;
            await axios
                .post(url, form)
                .then(res => {
                    this.getData();
                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "Sorry",
                        err.response.data.message
                    );
                });
        },
        async deletePaymentSalepage(id) {
            this.loading = true;
            const url = `/backend/s/${this.shop}/payments/manage-salepage/${this.salePage.id}/${id}`;
            await axios
                .delete(url)
                .then(res => {
                    this.getData();
                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert(
                        "error",
                        "Sorry",
                        err.response.data.message
                    );
                });
        },
        async getData() {
            await axios
                .get(
                    `/backend/s/${this.shop}/payments/manage-salepage/${this.salePage.id}`
                )
                .then(res => {
                    this.salePagePaymentData = res.data.paymentSalePage;
                    this.paymentData = res.data.payment;
                });
        },
        getBanks(query) {
            axios
                .get(`/ajax/s/${this.shop}/banks`, { params: { text: query } })
                .then((response) => {
                    this.banks = response.data.map((d) => {
                        return {
                            value: d.id,
                            label: d.name,
                        };
                    });
                })
                .catch((err) => {
                    console.log("error get banks info")
                });
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        },
        newPayment() {
            this.showPaymentLists = false;
            this.showAddNewPayment = true;
        },
        cancelAddPayment() {
            this.form = {};
            this.showPaymentLists = true;
            this.showAddNewPayment = false;
        },
        store() {
            this.loading = true;
            this.form.bank_id = this.bankSelected.value;
            axios
                .post(`/backend/s/${this.shop}/payments`, this.form)
                .then(res => {
                    this.showAddNewPayment = false;
                    this.getData();
                        
                    this.form.bank_id = "";
                    this.form.account_code = "";
                    this.form.holder_name = "";

                    this.loading = false;
                })
                .catch(err => {
                    this.messageAlert("error", "Sorry", "เกิดข้อผิดพลาด");
                });
        },
        onClose() {
            this.showPaymentLists = true;
            this.showAddNewPayment = false;

            this.form = {};
        }
    }
};
</script>
<style lang="scss" scoped>
.table-image {
    width: 120px;
}
.text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.table_modal thead th {
    border-top: none !important;
}
</style>
